/* Component Dependencies */
var swimmingFitnessTemplate = require('templates/swimming-fitness.hbs');
var swimmingLocalAreaTemplate = require('templates/swimming-localArea.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'swimming',
  template: {
    'swimming-fitness': swimmingFitnessTemplate,
    'swimming-localArea': swimmingLocalAreaTemplate
}});
